import { DatePipe } from "@angular/common";
import { AfterContentInit, Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { CentroCusto } from "src/app/models/centrocusto.model";
import { SpvAcompanhar } from "src/app/models/spv-acompanhar.model";
import { UsuarioCB } from "src/app/models/usuario-cb.model";
import { UsuarioAutorizacoes } from "src/app/models/usuario.autorizacoes.model";
import { CentroCustoService } from "src/app/services/centro.custo.service";
import { SpvService } from "src/app/services/spv.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { SCAMP_API_RPT } from "src/environments/environment";
import { ParametersOS } from "../../domain/viewmodels.models";
import { APP_SETTINGS } from "src/environments/environment";
import { CORES_STATUS_OS } from "src/app/shareds/constantes"

@Component({
  selector: "app-acompanhar-ss",
  templateUrl: "./acompanhar-ss.component.html",
  styleUrls: ["./acompanhar-ss.component.scss"],
  providers: [SpvService],
})
export class AcompanharSSComponent implements OnInit, AfterContentInit {
  constructor(
    private spvService: SpvService,
    private usuarioService: UsuarioService,
    private toastr: ToastrService,
    private router: Router,
    private formBuilder: FormBuilder,
    private centroCustoService: CentroCustoService
  ) { }

  spvs: SpvAcompanhar[] = [];
  voids: string[] = [];
  maximoLinhas = 8;
  usuarios: UsuarioCB[] = [];
  bgStatus: string[] = [
    "",
    "#808080",
    "#70ad47",
    "#a94442",
    "#5b9bd5",
    "#133050",
    "#a94442",
  ]; // Cores representativas para cada status uma SS

  bgStatusOS: string[] = CORES_STATUS_OS;

  isPesquisando = false; // indica se a aplicação esta no estado de buscando dados
  autorizacoes: UsuarioAutorizacoes = null;
  autorizacaoSpvOutrosUsuarios: boolean;

  public datePipe = new DatePipe("pt-BR");

  form: FormGroup = null;

  centrosDeCusto: CentroCusto[] = [];
  isProcessing: boolean = false;

  parameters: ParametersOS;
  labelCentroCusto: string = APP_SETTINGS.LabelCentroCusto;

  static dataFinalMenorDoQueDataInicial(group: AbstractControl): {
    [key: string]: boolean;
  } {
    const dataInicial = group.get("dataInicial");
    const dataFinal = group.get("dataFinal");

    if (!dataInicial || !dataFinal) {
      return undefined;
    }

    if (Date.parse(dataFinal.value) < Date.parse(dataInicial.value)) {
      return { dtFinalMenorDtInicial: true };
    }

    return undefined;
  }

  static dataInicioMuitoAntiga(group: AbstractControl): {
    [key: string]: boolean;
  } {
    const dataInicial = group.get("dataInicial");

    if (!dataInicial) {
      return undefined;
    }

    const NumberDataInicial = Date.parse(dataInicial.value);

    if (NumberDataInicial < 0) {
      return { dtInicioMuitoAntiga: true };
    }

    return undefined;
  }

  static dataFinalMuitoAntiga(group: AbstractControl): {
    [key: string]: boolean;
  } {
    const dataFinal = group.get("dataFinal");

    if (!dataFinal) {
      return undefined;
    }

    const NumberDataFinal = Date.parse(dataFinal.value);

    if (NumberDataFinal < 0) {
      return { dtFinalMuitoAntiga: true };
    }

    return undefined;
  }

  resetForm() {
    this.form = this.formBuilder.group(
      {
        dataInicial: [
          this.datePipe.transform(new Date(), "yyyy-MM-dd"),
          [Validators.required],
        ],
        dataFinal: [
          this.datePipe.transform(new Date(), "yyyy-MM-dd"),
          [Validators.required],
        ],
        usuarioSolicitouId: [this.usuarioService.getUsuarioLogadoId()],
        status: [""],
        usuarioSolicitante: [""],
        statusDescricao: [""],
        centroCustoDescricao: [""],
        centroCustoId: [""],
        tipoData: ["DataHoraUltimoStatus"],
        labelCentroCusto: [this.labelCentroCusto],
      },
      {
        validators: [
          AcompanharSSComponent.dataFinalMenorDoQueDataInicial,
          AcompanharSSComponent.dataInicioMuitoAntiga,
          AcompanharSSComponent.dataFinalMuitoAntiga,
        ],
      }
    );
  }

  ngAfterContentInit(): void {
    this.autorizacoes =
      this.usuarioService.getAutorizacoesJanelaPorRota("acompanhar-spv");
    this.autorizacaoSpvOutrosUsuarios =
      this.usuarioService.getAutorizacoesEspecificaPorRota(
        "acompanhar-spv",
        "spv-outros-usuarios"
      );
  }

  ngOnInit() {
    // this.autorizacoes = this.usuarioService.getAutorizacoesJanelaPorRota('acompanhar-spv');

    this.resetForm();
    this.setVoids();
    this.getCentroCustos();
    this.getUsuariosSolicitantes();
    document.getElementById("dataInicial").focus();
  }

  getUsuariosSolicitantes() {
    this.usuarioService.getUsuariosCB().subscribe(
      (response) => {
        this.usuarios = response;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter Usuarios Solicitantes");
      }
    );
  }

  getCentroCustos() {
    this.centroCustoService.getCentrosCustos().subscribe(
      (response: CentroCusto[]) => {
        this.centrosDeCusto = response;
      },
      (err: any) => {
        this.toastr.error("Erro ao tentar obter lista de Centros Custos");
      }
    );
  }

  getSpvSelecionada(id, modal) {
    // Exibir em um Modal maiores detalhes da Spv selecionada
  }

  submit(ocultarMsg: boolean) {
    if (this.form.valid) {
      this.isProcessing = true;

      this.spvService.getSSsPorPeriodo(this.form.value).subscribe(
        (response) => {
          this.spvs = response;
          console.log('!!', this.spvs);

          this.setVoids();

          if (this.spvs.length === 0) {
            if (ocultarMsg === false) {
              this.toastr.warning(
                "A pesquisa não retornou resultados com os parâmetros fornecidos"
              );
            }
          }

          this.isProcessing = false;
        },
        (err: any) => {
          this.toastr.error("Erro ao tentar obter SSs");
          console.log(err);
          this.isProcessing = false;
        }
      );
    }
  }

  reset() {
    this.resetForm();
    this.spvs = [];
    this.setVoids();
    this.isPesquisando = false;
  }

  changeStatus(status: string) {
    this.form.get("statusDescricao").setValue(status);
  }

  imprimir() {
    this.isPesquisando = true;
    this.submit(true);

    const cmbUsuarioSolicitante = document.getElementById(
      "usId"
    ) as HTMLSelectElement;
    const usuarioSolicitante =
      cmbUsuarioSolicitante.options[cmbUsuarioSolicitante.selectedIndex].text;

    this.form.get("usuarioSolicitante").setValue(usuarioSolicitante);

    //const data = `${this.form.get('dataInicial').value}/${this.form.get('dataFinal').value}/${this.form.get('usuarioSolicitouId').value}/${usuarioSolicitante}`;

    this.spvService.getAcompanharSPVs(this.form.value).subscribe(
      (response) => {
        if (response.success === true) {
          if (response.nenhumResultado === false) {
            window.open(
              `${SCAMP_API_RPT.root}${response.pathRpt}`,
              "_blank",
              "width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no"
            );
          } else {
            this.toastr.warning(response.msgErro);
          }
          this.isPesquisando = false;
        } else {
          this.toastr.error(response.msgErro);
          this.isPesquisando = false;
        }
      },
      (err: any) => {
        this.toastr.error(
          "Não foi possível se conectar ao servidor de relatórios",
          "Erro de Conexão"
        );
        this.isPesquisando = false;
      }
    );
  }
  private setVoids() {
    this.voids = [];

    if (this.spvs.length < this.maximoLinhas) {
      for (let i = this.spvs.length; i < this.maximoLinhas; i++) {
        this.voids.push("");
      }
    }
  }

  limparDataListCentroCustos() {
    this.form.get("centroCustoDescricao").setValue("");
    this.form.get("centroCustoId").setValue("");
  }

  changeDataListCentroCustos(value: string) {
    let item;
    if (value != "") {
      item = this.centrosDeCusto.filter((t) =>
        t.nome.toLowerCase().includes(value.toLowerCase())
      )[0];
    }
    if (item != undefined) {
      this.form.get("centroCustoDescricao").setValue(item.nome);
      this.form.get("centroCustoId").setValue(item.id);
    } else {
      this.form.get("centroCustoDescricao").setValue("");
      this.form.get("centroCustoId").setValue("");
    }
  }

  showOS(osId: number, spvId: number) {
    this.parameters = {
      osId: osId,
      spvId: spvId,
    };
  }
}
